import React, { useEffect, useRef, useState } from 'react';
import { FormGroup, Col, Row, Label, ModalBody, ModalFooter, Spinner, ModalHeader, Modal, Button, Card, CardBody } from 'reactstrap';
import moment from 'moment';
import { useSelector } from "react-redux";
import { getDocs, selectValues } from '../../../utils/fc';
import oikosApi from '../../../services/oikos';
import qs from 'qs';
import { notifyError, notifySuccess } from '../../../utils/notify';
import { IconButton, Typography } from '@mui/material';
import { Assignment } from '@material-ui/icons';
import currencyFormatter from '../../../utils/currencyFormatter';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import ModalFormEditFornecedor from '../ModalFormEditFornecedor/ModalFormEditFornecedor';
import {
  buildContrFornListFields,
  enrichEventosWithArquivos,
  enrichEventosWithContrato,
  fetchContrFornEventosWithBordero,
} from '../../../pages/MeusFornecedores/contratosTabHelpers';
import ContrFornParcelasTable from '../../../pages/MeusFornecedores/ContrFornParcelasTable';
import {
  CONTR_FORN_STATUS_EM_APROVACAO,
  CONTR_FORN_STATUS_EM_ASSINATURA,
  needsContrFornApproval,
} from '../ModalFormContrForn/contrFornApprovalRules';

const NENHUM_CONTRATADO_LABEL = 'Nenhum contratado';

const hasContrFornParte = (contrato = {}) => {
  const parteTab = String(contrato.contrForn_parteTab || '').trim().toLowerCase();
  const parteId = Number(contrato.contrForn_parteId) || 0;
  return (parteTab === 'pf' || parteTab === 'pj') && parteId > 0;
};

const ModalContrFornInfo = ( props ) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [listaParcelas, setListaParcelas] = React.useState([]);
  const [contrFornData, setContrFornData] = React.useState(props.contrFornData || {});
  const [fornecedor, setFornecedor] = React.useState({});
  const { user } = useSelector(state => state.auth);
  const [filesContrForn, setFilesContrForn] = React.useState([]);
  const [loadingSubmit, setLoadingSumbit] = useState(false);
  const [selPfsFornecedor, setSelPfsFornecedor] = React.useState([]);
  const [selPjsFornecedor, setSelPjsFornecedor] = React.useState([]);
  const [selOrcItems, setSelOrcItems] = React.useState([]);
  const autoOpenHandledRef = useRef(false);
  const arquivosReqRef = useRef(0);
  const temParteContratado = hasContrFornParte(contrFornData);
  const tipoContratadoLabel = !temParteContratado
    ? NENHUM_CONTRATADO_LABEL
    : (contrFornData.contrForn_parteTab === 'pf' ? 'Pessoa Física' : 'Pessoa Jurídica');
  const contratadoLabel = !temParteContratado
    ? NENHUM_CONTRATADO_LABEL
    : (contrFornData.contratado_nomePf || contrFornData.contratado_nomePj || NENHUM_CONTRATADO_LABEL);

  const handleClickOpenModal = () => setIsModalOpen(true);
  const handleClickCloseModal = () => setIsModalOpen(false);

  const getEventos = async ({ includeArquivos = false, contrato } = {}) => {
    const contratoRow = contrato?.contrForn_id ? contrato : contrFornData
    if (!contratoRow?.contrForn_id) return

    const reqId = arquivosReqRef.current + 1
    arquivosReqRef.current = reqId

    try {
      const eventos = await fetchContrFornEventosWithBordero(oikosApi, contratoRow.contrForn_id)
      let enriched = enrichEventosWithContrato(eventos, contratoRow)
      const precisaArquivos = enriched.some((evento) => (
        Number(evento.contrFornEvento_aprovLiberado) === 1
        || Number(evento.contrFornEvento_liberacaoAutomatica) === 1
      ))

      if (includeArquivos && precisaArquivos) {
        enriched = await enrichEventosWithArquivos(oikosApi, enriched)
      }

      if (arquivosReqRef.current !== reqId) return

      setListaParcelas(enriched)
      if (props.setListaParcelasDetails) {
        props.setListaParcelasDetails((prev) => ({
          ...prev,
          [contratoRow.contrForn_id]: enriched,
        }))
      }

      if (!includeArquivos && precisaArquivos) {
        enrichEventosWithArquivos(oikosApi, enriched).then((withArquivos) => {
          if (arquivosReqRef.current !== reqId) return
          setListaParcelas(withArquivos)
          if (props.setListaParcelasDetails) {
            props.setListaParcelasDetails((prev) => ({
              ...prev,
              [contratoRow.contrForn_id]: withArquivos,
            }))
          }
        }).catch((error) => {
          console.error('Failed to fetch arquivos das parcelas:', error)
        })
      }
    } catch (error) {
      console.error('Failed to fetch parcelas details:', error)
    }
  };

  const getFornecedor = async (parteTab, parteId) => {
    try {
      const resFornecedor = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: parteTab,
        data: {
          [`${parteTab}_id`]: parteId,
          [`${parteTab}_ativo`]: 1
        }
      })}`)

      console.log('resFornecedor', resFornecedor);

      setFornecedor(resFornecedor.data[0]);

    } catch (error) {
      console.error("Failed to fetch parcelas details:", error);
    }
  };

  const parcelasBatemVlrGlobalLabel = React.useMemo(() => {
    if (isLoading && !listaParcelas.length) return null;

    if (listaParcelas.length) {
      const sum = listaParcelas.reduce(
        (acc, ev) => acc + Number(ev.contrFornEvento_vlr || 0),
        0,
      );
      const global = Number(contrFornData.contrForn_vlrGlobal || 0);
      return Math.round(sum * 100) === Math.round(global * 100) ? 'Sim' : 'Não';
    }

    if (contrFornData.contrForn_parcelas_batem_vlrGlobal !== undefined) {
      return Number(contrFornData.contrForn_parcelas_batem_vlrGlobal) === 1 ? 'Sim' : 'Não';
    }

    return '—';
  }, [
    isLoading,
    listaParcelas,
    contrFornData.contrForn_vlrGlobal,
    contrFornData.contrForn_parcelas_batem_vlrGlobal,
  ]);

  async function handleReenviarParaAprovacao() {
    setLoadingSumbit(true);

    try {
      const vlrGlobal = Number(contrFornData.contrForn_vlrGlobal) || 0;
      if (!needsContrFornApproval(vlrGlobal)) {
        await oikosApi.post('/', {
          action: 'update',
          table: 'contrForn',
          data: {
            contrForn_id: contrFornData.contrForn_id,
            contrFornStatus_id: CONTR_FORN_STATUS_EM_ASSINATURA,
          },
        });
        notifySuccess('Contrato não requer aprovação (valor abaixo de R$ 10.000). Status atualizado para Em assinatura.');
        setIsModalOpen(false);
        return;
      }

    const queryString = `/?${qs.stringify({
      action: 'get',
      table: 'task',
      data: {
        task_tabRef: "contrForn",
        task_tabId: contrFornData.contrForn_id,
        taskStatus_id: 1
      },
    })}`;

    const resp = await oikosApi.get(queryString);

      if (resp.data.length > 0) {
        notifyError('Já há uma tarefa em aprovação para este contrato');
      return;
    }

    let contratadoNome = '';
    if (contrFornData.contrForn_parteTab === 'pf') {
        contratadoNome = selPfsFornecedor.find(f => f.value === contrFornData.contrForn_parteId)?.label || '';
    } else if (contrFornData.contrForn_parteTab === 'pj') {
        contratadoNome = selPjsFornecedor.find(f => f.value === contrFornData.contrForn_parteId)?.label || '';
      }

      await oikosApi.post('/', {
        action: 'update',
        table: 'contrForn',
        data: {
          contrForn_id: contrFornData.contrForn_id,
          contrFornStatus_id: CONTR_FORN_STATUS_EM_APROVACAO,
        },
      });

    const postBodyTask = {
      action: 'insert',
      table: 'task',
      data: {
        task_tabRef: 'contrForn',
        task_tabId: contrFornData.contrForn_id,
          pf_id: user.pf_id,
        task_prazo: moment().add(3, 'days').format('YYYY-MM-DD') || undefined,
        taskTp_id: 3,
        dpto_id: undefined,
          task_desc: `Aprovar contrato ${contrFornData.contrForn_num} ${contratadoNome}`,
          task_orientacao: 'Avalie o anexo desta tarefa. Após, clique em "Aprovar" ou "Rejeitar" de acordo com o seu julgamento',
      }
    };

    const responseTask = await oikosApi.post(`/`, postBodyTask);

    if (selOrcItems.length > 0 && ['Escritório de Projetos', 'Projetos'].includes(contrFornData.centroDeCusto)) {
      await oikosApi.post(`/`, {...postBodyTask, data: { ...postBodyTask.data, pf_id: 2, task_mae: responseTask.data[0].task_id}});
    } else if (selOrcItems.length > 0 && !(['Escritório de Projetos', 'Projetos'].includes(contrFornData.centroDeCusto))) {
      await oikosApi.post(`/`, {...postBodyTask, data: { ...postBodyTask.data, pf_id: 1, task_mae: responseTask.data[0].task_id}});
    }

      notifySuccess('Contrato reenviado para aprovação.');
    setIsModalOpen(false);
    } catch (error) {
      console.error('Erro ao reenviar para aprovação:', error);
      notifyError('Não foi possível reenviar o contrato para aprovação.');
    } finally {
      setLoadingSumbit(false);
    }
  }

  const fetchPfsFornecedoresForSelect = async () => {
    try {
      const res = await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {pf_fornecedor: 1, pf_ativo: 1});
      const sortedFavs = (res).sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      })

      setSelPfsFornecedor(sortedFavs);
    } catch (error) {
      console.error("Error fetching Pfs:", error);
      return [];
    }
  }

  const fetchPjsFornecedoresForSelect = async () => {
    try {
      const res = await selectValues('pj', 'pj_id', 'pj_razaosocial', {pj_fornecedor: 1, pj_ativo: 1});
      const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setSelPjsFornecedor(sortedFavs);
    } catch (error) {
      console.error("Error fetching Pjs:", error);
      return [];
    }
  }

  const fetchOrcItemsForSelect = async (centro_id) => {
    console.log('centro_id', centro_id)
    try {
      let dataOrcItems = {
        orcItem_ativo: 1,
        nivel2_id: centro_id,
      }

      const queryString = `/?${qs.stringify({
        action: 'get',
        table: 'viewRubr_OrcItem',
        fields: {
          orcItem_id: 'value',
          item_orcamentario: 'label'
        },
        data: dataOrcItems,
        order: 'label'
      })}`;

      const resp = await oikosApi.get(queryString);

      setSelOrcItems(resp.data);
    } catch (error) {
      console.error("Error fetching orcItems:", error);
      return [];
    }
  }

  async function fetchContrFornById(contrFornId) {
    const id = Number(contrFornId)
    if (!id) return null

    try {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'contrForn',
        data: {
          contrForn_id: id,
          contrForn_ativo: 1,
        },
        fields: buildContrFornListFields(true),
      })}`)
      return res?.data?.[0] || null
    } catch (error) {
      console.error('Erro ao carregar contrato de fornecedor:', error)
      return null
    }
  }

  async function resolveCentroDeCustoFromOrcItem(contrato) {
    if (!contrato?.orcItem_id) return contrato
    if (contrato.centroDeCusto && contrato.centroDeCustoRubr_id) return contrato

    try {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'viewRubr_OrcItem',
        data: { orcItem_id: contrato.orcItem_id },
        fields: {
          nivel2: 'centroDeCusto',
          nivel2_id: 'centroDeCustoRubr_id',
        },
      })}`)
      const row = res?.data?.[0]
      if (!row) return contrato

      return {
        ...contrato,
        centroDeCusto: contrato.centroDeCusto || row.centroDeCusto || null,
        centroDeCustoRubr_id: contrato.centroDeCustoRubr_id || row.centroDeCustoRubr_id || null,
      }
    } catch (error) {
      console.error('Erro ao resolver centro de custo do contrato:', error)
      return contrato
    }
  }

  async function loadData() {
    const contratoBase = props.contrFornData || {}
    setIsLoading(true)
    try {
      let contrato = { ...contratoBase }
      const fetchedContrForn = await fetchContrFornById(contrato.contrForn_id)
      if (fetchedContrForn) {
        contrato = { ...contrato, ...fetchedContrForn }
      }
      contrato = await resolveCentroDeCustoFromOrcItem(contrato)
      setContrFornData(contrato)
      const [, contrFornDocs] = await Promise.all([
        getEventos({ contrato }),
        getDocs('contrForn', contrato.contrForn_id),
        getFornecedor(contrato.contrForn_parteTab, contrato.contrForn_parteId),
      ])
      setFilesContrForn(contrFornDocs)
      fetchPfsFornecedoresForSelect()
      fetchPjsFornecedoresForSelect()
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!props.autoOpen) {
      autoOpenHandledRef.current = false;
      return;
    }
    if (autoOpenHandledRef.current) return;

    autoOpenHandledRef.current = true;
    handleClickOpenModal()
    loadData()
  }, [props.autoOpen]);

  React.useEffect(() => {
    console.log('contrFornData', contrFornData)
    if (!contrFornData.centroDeCustoRubr_id) return; // Prevent running without centroDeCustoRubr_id
    if(contrFornData.centroDeCustoRubr_id) {
      fetchOrcItemsForSelect(contrFornData.centroDeCustoRubr_id);
    }
  }, [contrFornData.centroDeCustoRubr_id]);

  return (
    <>
      <IconButton
        size={props.triggerSize || 'medium'}
        title={props.triggerTitle}
        onClick={() => {
          handleClickOpenModal()
          loadData()
        }}
      >
        {isLoading ? <Spinner /> : (props.triggerIcon || <Assignment />)}
      </IconButton>

      <Modal
        isOpen={isModalOpen}
        toggle={handleClickCloseModal}
        size="xl"
        zIndex={2000}
        >
        <ModalHeader>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Contrato de fornecedor {contrFornData.contrForn_num}
          </Typography>
        </ModalHeader>
        <ModalBody>
          {isLoading && listaParcelas.length === 0 ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spinner color="primary" />
            </div>
          ) : (
          <Tabs>
            <TabList>
              <Tab>Geral</Tab>
              <Tab>Eventos</Tab>
            </TabList>

            <TabPanel>
              <Row>
                <Col sm={3}>
                  <FormGroup>
                    <Label>
                      Centro de custo
                    </Label>
                    <br /><span style={{fontWeight: 'bold'}}>{contrFornData.centroDeCusto}</span>
                  </FormGroup>
                </Col>

                  <Col sm={3}>
                    <FormGroup>
                      <Label>
                        Projeto
                      </Label>
                      <br /><span style={{fontWeight: 'bold'}}>{contrFornData.proj_nome}</span>
                    </FormGroup>
                  </Col>

                <Col sm={3}>
                  <FormGroup>
                    <Label>
                      Item orçamentário
                    </Label>
                    <br /><span style={{fontWeight: 'bold'}}>{contrFornData.orcItem_desc}</span>
                  </FormGroup>
                </Col>

                <Col sm={3}>
                  <FormGroup>
                    <Label>
                      Parcelas batem com valor global do contrato?
                    </Label>
                    <br /><span style={{fontWeight: 'bold'}}>{parcelasBatemVlrGlobalLabel ?? <Spinner size="sm" />}</span>
                  </FormGroup>
                </Col>

                <Col sm={6}>
                  <FormGroup>
                    <Label>
                      Objeto resumido
                    </Label>
                    <br /><span style={{fontWeight: 'bold'}}>{contrFornData.contrForn_desc}</span>
                  </FormGroup>
                </Col>

                <Col sm={6}>
                  <FormGroup>
                    <Label>
                      Contrato em vigência?
                    </Label>
                    <br /><span style={{fontWeight: 'bold'}}>{new Date(contrFornData.contrForn_dtAssin).getTime() < new Date().getTime() ? 'Sim' : 'Não'}</span>
                  </FormGroup>
                </Col>

                <Col sm={12}>
                  <Label>
                    Objeto do contrato
                  </Label>
                    <br /><span>{contrFornData.contrForn_obj}</span>
                </Col>

                <Col sm={12} className='pt-4'>
                  <FormGroup>
                    <Label>
                      Campo de detalhamento do serviço
                    </Label>
                    <br /><span>{contrFornData.contrForn_detalhamento}</span>
                  </FormGroup>
                </Col>

                <Col sm={4}>
                  <FormGroup>
                    <Label>
                      Modelo de minuta
                    </Label>
                    <br /><span style={{fontWeight: 'bold'}}>{contrFornData.tpMinuta_nome}</span>
                  </FormGroup>
                </Col>

                <Col sm={4}>
                  <FormGroup>
                    <Label>
                      Tipo de contratado
                    </Label>
                    <br /><span>{tipoContratadoLabel}</span>
                  </FormGroup>
                </Col>

                <Col sm={4}>
                  <FormGroup>
                    <div className="d-flex">
                      <Label>
                        Contratado
                      </Label>
                    </div>
                    <span style={{fontWeight: 'bold'}}>{contratadoLabel}</span>
                  </FormGroup>
                </Col>

                {/*
                <Col sm={4}>
                  <FormGroup>
                    <Label>
                      Data da assinatura
                    </Label>
                    <DatePicker
                      placeholderText="__/__/_____"
                      locale="pt-BR"
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      selected={contrFornData.contrForn_dtAssin ? moment(contrFornData.contrForn_dtAssin).toDate() : null}
                      onChange={date => {
                        if (date) {
                          setContrFornData({ ...contrFornData, contrForn_dtAssin: moment(date).format('YYYY-MM-DD') });
                        } else {
                          setContrFornData({ ...contrFornData, contrForn_dtAssin: null });
                        }
                      }}
                    />
                  </FormGroup>
                </Col>
                */}

                <Col className="pt-4" sm={12}>
                  <FormGroup>
                    <Label>
                      Tipo de contrato
                    </Label>
                    <br /><span style={{fontWeight: 'bold'}}>{contrFornData.contrFornTp_nome}</span>
                  </FormGroup>
                </Col>

                <Col className="pt-4" sm={4}>
                  <FormGroup>
                    <Label>
                      Data Início Vigência
                    </Label>
                    <br /><span style={{fontWeight: 'bold'}}>{moment(contrFornData.contrForn_dtVigIni).format('DD/MM/YYYY')}</span>
                  </FormGroup>
                </Col>

                <Col className="pt-4" sm={4}>
                  <FormGroup>
                    <Label>
                      Data Fim Vigência
                    </Label>
                    <br /><span style={{fontWeight: 'bold'}}>{moment(contrFornData.contrForn_dtVigFim).format('DD/MM/YYYY')}</span>
                  </FormGroup>
                </Col>

                <Col className="pt-4" sm={4}>
                  <FormGroup>
                    <Label>
                      Valor
                    </Label>
                    <br /><span style={{fontWeight: 'bold'}}>{currencyFormatter.format(contrFornData.contrForn_vlrGlobal)}</span>
                  </FormGroup>
                </Col>

                <Col className="d-flex align-items-center pt-4" sm={4}>
                  <span className="mr-2">O valor global do contrato não é fixo?</span>
                  <input disabled type="checkbox" name="valor-fixo" id="valor-fixo" onChange={(e) => {setContrFornData({...contrFornData, contrForn_vlrFixo: e.target.checked ? 0 : 1})}}/>
                </Col>

                <Col className="d-flex align-items-center pt-4" sm={4}>
                  <span className="mr-2">O contrato prevê que as parcelas possuem dia fixo para pagamento?</span>
                  <input disabled type="checkbox" name="data-fixa" checked={contrFornData.contrForn_dtPgtoFixa === 1} id="data-fixa" onChange={(e) => {setContrFornData({...contrFornData, contrForn_dtPgtoFixa: e.target.checked ? 1 : 0})}}/>
                </Col>

                <Col className="d-flex align-items-center pt-4" sm={4}>
                  <span className="mr-2">Renovação automática?</span>
                  <input disabled type="checkbox" name="valor-fixo" id="valor-fixo" onChange={(e) => {setContrFornData({...contrFornData, contrForn_renovacaoAutomatica: e.target.checked ? 1 : 0})}}/>
                </Col>

                <Col sm={12} className='pt-4'>
                  <Label>
                    Observação
                  </Label>
                  <br /><span>{contrFornData.contrForn_obs}</span>
                </Col>
              </Row>

              <Col sm={12}>
                <div><br /><span style={{fontWeight: 'bold'}}>Número: </span>{contrFornData.contrForn_num}</div>
                <div>
                  <br /><span style={{fontWeight: 'bold'}}>
                    Contratado:
                  </span>
                  {contratadoLabel}
                  {temParteContratado && (
                  <ModalFormEditFornecedor
                    isPf={contrFornData.contrForn_parteTab === 'pf'}
                    contrForn_parteId={contrFornData.contrForn_parteId}
                    setContrFornData={setContrFornData}
                    contrFornData={contrFornData}
                  />
                  )}
                </div>
                <div><br /><span style={{fontWeight: 'bold'}}>Valor: </span>{currencyFormatter.format(contrFornData.contrForn_vlrGlobal)}</div>
                <div className='pt-4'><br /><span style={{fontWeight: 'bold'}}>Documentos: </span></div>
                {filesContrForn.map(i => (
                  <>
                    <Card>
                      <CardBody>
                        <Row className="align-items-center justify-content-between">
                          <Col>
                            <Row>
                              <Col xs="auto">
                                <p style={{ fontWeight: 'bold' }}>
                                  <a
                                  href={`https://oikos.ecoss.is/oikos/${i.arquivo_caminho}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  >
                                  {i.documento_desc}
                                  </a>
                                </p>
                              </Col>
                            </Row>

                          </Col>
                          {user.perm_id === 1 &&
                            <Button
                              title="Excluir"
                              className="mr-2"
                              color="light"
                              size="sm"
                              onClick={() => this.setState({ deleteModalOpen: true, arquivoData: i })}
                            >
                              <i className="ri-delete-bin-6-line" />
                            </Button>
                          }
                        </Row>
                      </CardBody>
                    </Card>
                  </>
                ))}
              </Col>

              <Col sm={12}>
              </Col>

              <Col sm={12}>
              </Col>

              <Col sm={12}>
              </Col>

              <Col sm={12}>
              </Col>

              <Col sm={4}>
              </Col>

              <Col sm={4}>
              </Col>

              <Col sm={4}>
              </Col>

              <Col sm={4}>
              </Col>

              <Col sm={4}>
              </Col>

              <Col sm={4}>
              </Col>

              <Col sm={4}>
              </Col>

              <Col sm={3}>
              </Col>

              <Col sm={12}>
              </Col>

              <Col sm={12}>
              </Col>
            </TabPanel>

            <TabPanel>
              <Col sm={12}>
                <ContrFornParcelasTable
                  data={listaParcelas}
                  isLoading={isLoading}
                  contrFornData={contrFornData}
                  fornecedor={fornecedor}
                  setFornecedor={setFornecedor}
                  onParcelasChange={setListaParcelas}
                  getEventos={getEventos}
                  updateOneEvento={props.updateOneEvento}
                  onContrFornParteUpdated={(nextContrForn) => {
                    setContrFornData((prev) => ({ ...prev, ...nextContrForn }));
                  }}
                />
              </Col>
            </TabPanel>
          </Tabs>
          )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={handleClickCloseModal}>Fechar</Button>
          {(contrFornData.contrFornStatus_id === 8 && !loadingSubmit) ?
            <Button disabled={loadingSubmit} color="primary" onClick={() => handleReenviarParaAprovacao(contrFornData)}>Reenviar para aprovação</Button> : (contrFornData.contrFornStatus_id === 8 && loadingSubmit) ?
            <Spinner /> : <></>
          }
        </ModalFooter>
      </Modal>
    </>
  )
}

export default ModalContrFornInfo;
export { ButtonLiberarPagamento } from './ButtonLiberarPagamento';
